module.exports = __webpack_public_path__ + "static/m4-8b4d0e9b1a61e1b4e1582b8fdc1753be.png";